export default function (nga, admin) {
    return nga.menu()
        .addChild(nga.menu()
            .title('Edition')
            .icon('<span class="fa fa-th-list fa-fw"></span>')
            .addChild(nga.menu(admin.getEntity('groups')).icon('<span class="fa fa-users fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('activities')).icon('<span class="fa fa-play fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('periodic_events')).icon('<span class="fa fa-clock-o fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('exercises')).icon('<span class="fa fa-file-o fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('cognitive_functions')).icon('<span class="fa fa-tags fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('categories')).icon('<span class="fa fa-tags fa-fw"></span>'))
        )
        .addChild(
            nga.menu()
              .title('Calendar')
              .link('/calendar')
              .active(function(path) {
                return path.indexOf('/calendar') === 0;
              })
            .icon('<span class="fa fa-calendar fa-fw"></span>'))
        .addChild(nga.menu()
            .title('Statistics')
            .icon('<span class="fa fa-line-chart fa-fw"></span>')
            .addChild(nga.menu(admin.getEntity('evaluations')).icon('<span class="fa fa-table fa-fw"></span>'))
            .addChild(nga.menu(admin.getEntity('evaluations_grouped')).icon('<span class="fa fa-table fa-fw"></span>'))
            .addChild(
                nga.menu()
                    .title('Exercises by CF').link('/stats/exercises_per_cf')
                    .icon('<span class="fa fa-bar-chart fa-fw"></span>')
            )
            .addChild(
                nga.menu()
                    .title('Performed exercises').link('/stats/gt_exercise_distribution')
                    .icon('<span class="fa fa-pie-chart fa-fw"></span>')
            )
        )
        .addChild(
            nga.menu()
            .title('Help')
            .link('/help')
            .active(function(path) {
                return path.indexOf('/help') === 0;
            })
            .icon('<span class="fa fa-question-circle fa-fw"></span>'))
    ;
}



// WEBPACK FOOTER //
// ./js/menu.js